import React, { createContext, useEffect } from "react";
import { useSnackbar } from "notistack";
import { authReducer } from '../../reducers'
import { LoadingScreen } from "../../components";
import { UpdateLogin, Login, logoutuser, generateTocken } from '../../services/login';

import { confirmDialog } from "../../components";


const authState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
  } else {
    localStorage.removeItem("accessToken");
    window.localStorage.clear();
  }
};
const setUsuario = (usuario) => {
  if (usuario) {
    window.localStorage.setItem('usuario', JSON.stringify(usuario));
  } else {
    localStorage.removeItem("usuario");
  }
};
export const restoreUser = () => {
  let settings = null;

  try {
    const storedData = window.localStorage.getItem('usuario');

    if (storedData) {
      settings = JSON.parse(storedData);
    }
  } catch (err) {
    // If stored data is not a strigified JSON this will fail,
    // that's why we catch the error
  }

  return settings;
};
const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
};



const AuthContext = createContext({
  ...authState,
  method: "JWT",
  login: () => Promise.resolve(),
  reset: () => Promise.resolve(),
  logoutUser: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(authReducer, authState);
  const [loading, setLoading] = React.useState(true);

  const { enqueueSnackbar } = useSnackbar();

  const login = async (email, password) => {
    dispatch({
      type: "INITIALISE",
      payload: {
        isAuthenticated: false,
        isInitialised: true,
        user: null,
      },
    });
    var user = null;
    setLoading(true)
    await generateTocken()
      .then(async (respond) => {
        setSession(respond.accessToken)


        await Login(email, password)
          .then(async (respond) => {
            user = respond;
            if(user.rolName!="USUARIO"){
              await setUsuario(user);
              dispatch({
                type: "LOGIN",
                payload: {
                  user,
                },
              });
              setLoading(false);
              enqueueSnackbar("Bienvenidos", {
                variant: "success",
              });
            }else{
              setLoading(false);

              enqueueSnackbar(
                "Actualmente no tienes acceso a este servicio",
                {
                  variant: "error",
                }
              );
            }
         
          })
          .catch((error) => {
            if (error?.data?.reason==='Active Session') {
              confirmDialog('Usted tiene sesiones activas. ¿Desea cerrarlas?', () =>
                logoutAndLogin(email, password)
              );
            } else {
              if(error?.data?.reason==='Invalid credentials')  {
                enqueueSnackbar(
                  "Contraseña inválida.",
                  {
                    variant: "error",
                  }
                );
              }else{

                if(error?.data?.reason==="Not registered"){
                  enqueueSnackbar(
                    "Usuario no registrado",
                    {
                      variant: "error",
                    }
                  );
                }else{
                  enqueueSnackbar(
                    "Actualmente no tienes acceso a este servicio",
                    {
                      variant: "error",
                    }
                  );
                }
         
              }
            }
            setLoading(false);
            setLoading(false)
          });
      })
      .catch((error) => {
        setLoading(false)

      });
  };

  const reset = async () => {
    await setSession(null);
    setLoading(false)
    dispatch({
      type: "INITIALISE",
      payload: {
        isAuthenticated: false,
        isInitialised: true,
        user: null,
      },
    });
    clearCacheData();

  };
  const logoutUser = async () => {
    setLoading(true);
    var usuario = restoreUser();
    await logoutuser(usuario.userName)
      .then(async (respond) => {
        reset();
        enqueueSnackbar(
          respond.activeSession,
          {
            variant: "success",
          }
        );
        dispatch({
          type: "LOGOUT",
        });
      });
  };
  const logoutUser2 = async (usuario) => {
    setLoading(true);
    await logoutuser(usuario)
      .then((respond) => {
        reset();
        enqueueSnackbar(
          respond.data.dt1,
          {
            variant: "success",
          }
        );
        dispatch({
          type: "LOGOUT",
        });
      }).catch((err => {
      }));
  };
  const logoutAndLogin = async (usuario, password) => {
    setLoading(true);
    await logoutuser(usuario)
      .then(async (respond) => {
        reset();

        dispatch({
          type: "LOGOUT",
        });
        await generateTocken()
          .then(async (respond) => {
            setSession(respond.accessToken)
            setLoading(false)
            await login(usuario, password)

          })
          .catch((error) => {
            setLoading(false)

          });
      });


  };




  useEffect(() => {
    var user = null;

    const initialise = async () => {
      setLoading(true)
      const accessToken = window.localStorage.getItem("accessToken");
      if (accessToken) {
        const restoredSettings = restoreUser();
        if (restoredSettings) {
          user = restoredSettings;
          await setUsuario(user);

          dispatch({
            type: "LOGIN",
            payload: {
              user,
            },
          });
          setLoading(false);
        } else {
          reset()
        }


        setLoading(false)
      } else {
        await generateTocken()
          .then(async (respond) => {
            setSession(respond.accessToken)
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)

          });

      }


    };

    initialise();

  }, [enqueueSnackbar]);
  // useEffect(() => {

  //   const initialise = async () => {
  //     const accessToken = window.localStorage.getItem("accessToken");
  //     if (accessToken) {

  //       setLoading(true);
  //       var user = null;

  //       await UpdateLogin(accessToken)
  //         .then(async (respond) => {
  //           user = respond.data;
  //          await setSession(user.dt14);

  //           dispatch({
  //             type: "LOGIN",
  //             payload: {
  //               user,
  //             },
  //           });
  //           setLoading(false);
  //           enqueueSnackbar("Bienvenidos", {
  //             variant: "success",
  //           });
  //         })
  //         .catch((error) => {
  //           if (error.status === 401 || error.status === 500) {
  //             clearCacheData();
  //             reset();
  //           } else {

  //             setLoading(false)
  //             enqueueSnackbar(
  //               error.statusText,
  //               {
  //                 variant: "error",
  //               }
  //             );
  //             logoutUser()
  //           }

  //         });

  //       setLoading(false)

  //     } else {
  //       clearCacheData();
  //       reset();
  //       dispatch({
  //         type: "INITIALISE",
  //         payload: {
  //           isAuthenticated: false,
  //           user: null,

  //         },
  //       });
  //       setLoading(false)
  //     }
  //   };

  //   initialise();

  // }, [enqueueSnackbar]);
  return (
    <AuthContext.Provider value={{ ...state, method: "JWT", login, reset, logoutUser }}>
      {loading ? <LoadingScreen /> : children}
    </AuthContext.Provider>
  );
};

export default AuthContext;